import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment';
import EventIcon from './EventIcon';

function formatDateRange(route) {
  const date1 = moment(route.start);
  const date2 = moment(route.end);
  let days = date1.format('MMM DD');
  if (!date2.isValid()) {
    return days;
  }
  if (!date1.isSame(date2)) {
    days = `${days}-${date2.format('DD')}`;
  }
  return days;
}

class EventMapItem extends React.Component {
  componentWillReceiveProps(nextProps) {
    if (this.props.selected !== nextProps.selected && nextProps.selected) {
      this.node.scrollIntoView();
    }
  }
  onClick = () => {
    console.log('Event Clicked on:', this.props.event.id);
    this.props.onSelect(this.props.event.id);
  };
  render() {
    const event = this.props.event;
    const listBG = this.props.selected ? '#f0f0f0' : '';

    return (
      <li
        ref={node => (this.node = node)}
        key={event.id}
        className="map-item pointer-hover"
        data-route={event.id}
        onClick={this.onClick}
        style={{
          backgroundColor: listBG,
        }}
      >
        <div className="event-date" data-item={this.props.parentId}>
          <EventIcon eventType={event.event_type} />{' '}
          <strong className="event-day">{formatDateRange(event)}</strong>
        </div>
        <div className="event-location">
          <strong>
            <span>{event.name && event.name}</span>
          </strong>
          <br />
          <span>
            {event.place.city}, {event.place.state}
          </span>
          <span>{event.notes}</span>
        </div>
      </li>
    );
  }
}

EventMapItem.propTypes = {
  selected: PropTypes.bool.isRequired,
  event: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    start: PropTypes.string,
    end: PropTypes.string,
    event_type: PropTypes.string,
  }).isRequired,
  parentId: PropTypes.number,
  onSelect: PropTypes.func.isRequired,
};
EventMapItem.defaultProps = {
  parentId: null,
};
export default EventMapItem;



// WEBPACK FOOTER //
// src/routes/tours/components/EventMapItem.js